import { Injectable } from '@angular/core';

import { ICONS } from '../icons/icons.service';

const ICON_PER_ENTITY: Record<string, string> = {
  site: ICONS.mapPinSimple,
  job: ICONS.calendarCheck,
  vehicle: ICONS.truckTrailer,
  vehicle_registration: ICONS.truckTrailer,
  trailer: ICONS.shippingContainer,
  trailer_registration: ICONS.shippingContainer,
  driver: ICONS.userBold,
  driver_registration: ICONS.userBold,
  route: ICONS.path,
  temperature: ICONS.thermometer,
  capacity_resource: ICONS.handbagSimple,
  work_regulation: ICONS.scales,
  expertise: ICONS.medal,
  commodity: ICONS.storefront,
  product: ICONS.drop,
  company: ICONS.factory,
  route_action: ICONS.mapPinSimple,
  site_schedule_window: ICONS.calendar,
  driver_work_window: ICONS.calendar,
  job_recurrence_visit: ICONS.arrowsClockwise,
  flow_kind: ICONS.flowArrow,
  equipment: ICONS.toolbox,
  job_waste_container_step: ICONS.lineSegments,
  compartment: ICONS.squareSplitHorizontal,
  container: ICONS.cubeTransparent,
  contact: ICONS.contact,
  geographic_area: ICONS.mapTrifold,
  infrastructure: ICONS.garage,
  geo_arc: ICONS.graph
};

/** The icon standing for an entity type wherever it is shown, by entity type name. */
export function entityIconFor(name: string): string {
  return ICON_PER_ENTITY[name.toLowerCase()] || ICONS.list;
}

@Injectable({
  providedIn: 'root'
})
export class EntityIconService {
  protected readonly icons = ICONS;

  constructor() {}

  getEntityIcon(name: string): string {
    return entityIconFor(name);
  }
}
